import { Injectable } from '@angular/core';
import {Regione} from "../models/Regione";
import {FormGroup} from "@angular/forms";
import {Stato} from "../models/Stato";
import {Provincia} from "../models/Provincia";
import {Citta} from "../models/Citta";
import {Cliente} from "../models/Cliente";
import {Fornitore} from "../models/Fornitore";
import {Indirizzo} from "../models/Indirizzo";
import _ from "lodash";

@Injectable({
   providedIn: 'root'
})
export class IndirizzoService {

   public arrStati: Stato[] = []
   arrRegioni: Regione[] = [];
   arrProvince: Provincia[] = [];
   arrCitta: Citta[] = [];
   is_init = false
   frm: FormGroup = new FormGroup({})
   public model: Cliente | Fornitore | null = null

   constructor() {
   }

   async fetchStati() {
      Stato.getStati().then(res => {
         this.arrStati = res
      }).catch(err => {
         console.error(err)
      })
   }

   onChangeStato(value: any) {
      console.log(value)
      if (value == 'Italia') {
         this.frm.get('indirizzo')?.get('regione')?.enable()
         this.fetchRegioni()
      } else {
         this.frm.get('indirizzo')?.get('regione')?.disable()
         this.frm.get('indirizzo')?.get('regione')?.patchValue(null)
         this.frm.get('indirizzo')?.get('provincia')?.disable()
         this.frm.get('indirizzo')?.get('provincia')?.patchValue(null)
         this.frm.get('indirizzo')?.get('citta')?.disable()
         this.frm.get('indirizzo')?.get('citta')?.patchValue(null)
      }
   }

   async fetchRegioni() {
      await Regione.getRegioni().then(
         (regioni) => {
            this.arrRegioni = regioni
            if (this.is_init) {
               this.frm.get('indirizzo')?.get('regione')?.patchValue(this.model?.data.indirizzo?.regione.toString())
               this.regioneChange(this.model?.data.indirizzo?.regione.toString())
            }
         }
      ).catch(err => {
         console.error(err)
      })
   }

   async regioneChange(reg: any) {
      if (!reg) return;
      this.frm.get('indirizzo')?.get('provincia')?.patchValue(null)
      this.frm.get('indirizzo')?.get('provincia')?.enable()
      this.frm.get('indirizzo')?.get('citta')?.patchValue(null)
      this.frm.get('indirizzo')?.get('citta')?.disable()

      await Provincia.getProvince(reg).then((province) => {
         this.arrProvince = province
         if (this.is_init) {
            console.log("INIT")
            this.frm.get('indirizzo')?.get('provincia')?.enable()
            this.frm.get('indirizzo')?.get('provincia')?.patchValue(this.model?.data?.indirizzo?.provincia?.toString())
            this.provinciaChange(this.model?.data?.indirizzo?.provincia?.toString())
         }
         this.arrCitta = []
      })
   }

   provinciaChange(prov: any) {
      if (!prov) return;
      Citta.getCitta(prov).then(
         (citta) => {
            this.arrCitta = citta
            console.log(this.is_init)
            this.frm.get('indirizzo')?.get('citta')?.enable()
            if (this.is_init) this.frm.get('indirizzo')?.get('citta')?.patchValue(this.model?.data?.indirizzo?.citta?.toString())
         }).finally(() => {
         this.is_init = false
      })
   }

   async patchValueIndirizzo() {
      let indirizzo = new Indirizzo(this.model?.data.indirizzo)
      if (this.model?.data.id) {
         console.log(this.model?.data)
         if (this.model.data.indirizzo?.stato) {
            await this.frm.get('indirizzo')?.get('stato')?.patchValue(indirizzo.data.stato.toString())
            let statoSel = _.find(this.arrStati, x => x.data.id == indirizzo.data.stato)
            this.onChangeStato(statoSel?.data.nome)
         }
      }
   }

}
